import { render, staticRenderFns } from "./ManageMedicationPlan.vue?vue&type=template&id=9649bedc&scoped=true"
import script from "./ManageMedicationPlan.vue?vue&type=script&lang=js"
export * from "./ManageMedicationPlan.vue?vue&type=script&lang=js"
import style0 from "./ManageMedicationPlan.vue?vue&type=style&index=0&id=9649bedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9649bedc",
  null
  
)

export default component.exports